import { useEffect, useState } from 'react';
import { Alert, Button, Collapse, Form, Space, Tooltip, Typography } from 'antd';
import { apiClient, apiErrorMessage } from '../../utils';
import { Field, FieldGroup, Grid } from '../../models';
import { FieldFormItem } from './field-form-item';
import { FormInstance, useForm } from 'antd/lib/form/Form';
import { InfoCircleOutlined } from '@ant-design/icons';

export function NewGridRowPage(props: { grid?: Grid; onSaved: () => void; rowId?: string }) {
  const { Text } = Typography;
  const [form] = useForm();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<any>();

  useEffect(() => {
    if (!props.grid) {
      return;
    }
    const fields = props.grid?.fields?.filter(f => f.defaultValue !== null && f.defaultValue !== undefined);
    for (const field of fields) {
      const fieldValue: any = {};
      fieldValue[field.id] = field.defaultValue;
      form.setFieldsValue(fieldValue);
    }
  }, [form, props.grid]);

  const onFinish = (values: any) => {
    setLoading(true);
    setErrors(undefined);

    const cellValues: any[] = [];

    for (let key in values) {
      if (key.includes('_templateValues')) {
        cellValues.forEach((item, index) => {
          console.log(item.fieldId, key.split('_templateValues')[0]);
          if (item.fieldId === key.split('_templateValues')[0]) {
            item.templateValue = values[key];
          }
        });
        continue;
      }

      if (key.includes('_uom')) {
        cellValues.forEach((item, index) => {
          if (item.fieldId === key.split('_uom')[0]) {
            item.value = item.value + '###' + values[key];
          }
        });
        continue;
      }

      let value = values[key];
      const field = props.grid?.fields?.find(m => m.id === key);

      if (field?.dataType === 'DATE') {
        value = value?.format('YYYY-MM-DD');
      } else if (field?.dataType === 'DATETIME') {
        value = value?.format('YYYY-MM-DD HH:mm');
      } else if (field?.dataType === 'TIME') {
        value = value?.format('HH:mm');
      } else if (field?.dataType === 'MULTIPICKLIST') {
        value = value?.length ? value.join('###') : null;
      } else if (field?.dataType === 'MULTIFOREIGNKEY') {
        value = value?.length ? value.join('###') : null;
      }

      if (value !== null && value !== undefined) {
        cellValues.push({ fieldId: key, value, templateValue: '' });
      }
    }

    const body = {
      gridId: props.grid?.id,
      parentRecordId: props.rowId ? props.rowId : undefined,
      fields: cellValues,
    };
    apiClient
      .post(`records/records`, body)
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
        setErrors(reason?.response?.data?.errors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {errors && (
        <Alert
          type="error"
          style={{ marginBottom: '2rem' }}
          message={
            <Space direction="vertical">
              <Text strong type="danger">
                Kural hataları
              </Text>
              {errors.map((ve: any) => (
                <>
                  <Text strong>{props.grid?.fields?.find(fg => fg.id === ve.id)?.name}</Text>
                  <ul style={{ marginBottom: 0 }}>
                    {ve.errors.map((e: string) => (
                      <li>{e}</li>
                    ))}
                  </ul>
                </>
              ))}
            </Space>
          }
        />
      )}

      <Form form={form} layout="horizontal" labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} name="basic" onFinish={onFinish}>
        <ItemsPanel form={form} grid={props.grid} level={[]} panelScheme={props.grid?.scheme} />
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            width: '100%',
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'flex-end',
            paddingTop: '1rem',
          }}
        >
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Ekle
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
}

function ItemsPanel(props: { form: FormInstance<any>; grid?: Grid; level: string[]; panelScheme?: any[] }) {
  const [fields, setFields] = useState<Field[]>();
  const [fieldGroups, setFieldGroups] = useState<FieldGroup[]>();
  const [panelScheme, setPanelScheme] = useState<any[]>();
  const allowRecordWithErrors = props.grid?.allowRecordWithErrors;

  useEffect(() => {
    setFields(props.grid?.fields);
  }, [props.grid?.fields]);

  useEffect(() => {
    setFieldGroups(props.grid?.fieldGroups);
  }, [props.grid?.fieldGroups]);

  useEffect(() => {
    setPanelScheme(props.panelScheme);
  }, [props.panelScheme]);

  const RecordFormItem = ({ item }: any) => {
    if (item.itemType === 'field') {
      const field = fields?.find(f => f.id === item.id);
      if (field && !field.hideOnNewRecord && field.dataType !== 'AUTOINC') {
        return FieldTr({ field, form: props.form, allowRecordWithErrors: allowRecordWithErrors });
      }
    } else if (item.itemType === 'fieldGroup') {
      const fieldGroup = fieldGroups?.find(g => g.id === item.id);
      if (fieldGroup && !fieldGroup.hideOnNewRecord) {
        const fieldGroupChildren = panelScheme?.find(s => s.id === fieldGroup.id)?.children as any[];
        return FieldGroupTr({
          form: props.form,
          grid: props.grid,
          fieldGroup,
          level: props.level,
          panelScheme: fieldGroupChildren,
        });
      }
    }
    return null;
  };

  return (
    <>
      {panelScheme?.map((item: any, i: number) => (
        <RecordFormItem key={`item-${item.id}`} index={i} item={item} />
      ))}
    </>
  );
}

function FieldGroupTr(props: { form: FormInstance<any>; grid?: Grid; fieldGroup: FieldGroup; level: string[]; panelScheme?: any[] }) {
  const [isActive, setIsActive] = useState(true);
  const [level, setLevel] = useState<string[]>([]);
  const [panelScheme, setPanelScheme] = useState<any[]>();

  const { Text } = Typography;

  useEffect(() => {
    setPanelScheme(props.panelScheme);
  }, [props.panelScheme]);

  useEffect(() => {
    setLevel(props.level);
  }, [props.level]);

  const onChange = () => {
    setIsActive(!isActive);
  };

  if (!props.grid || !panelScheme) {
    return null;
  }

  return (
    <Collapse
      activeKey={isActive ? props.fieldGroup.id : undefined}
      style={{ marginTop: '1rem', marginBottom: '1rem', borderColor: props.fieldGroup.hexCodeBackground }}
      onChange={onChange}
    >
      <Collapse.Panel
        style={{ backgroundColor: props.fieldGroup.hexCodeBackground, borderColor: props.fieldGroup.hexCodeBackground }}
        header={
          <Space>
            <span style={{ color: props.fieldGroup.hexCodeTitle, fontWeight: 700 }}>{props.fieldGroup.name}</span>
            <Tooltip title={props.fieldGroup.description}>
              <Text type="secondary">
                <InfoCircleOutlined />
              </Text>
            </Tooltip>
          </Space>
        }
        key={props.fieldGroup.id}
      >
        <ItemsPanel form={props.form} grid={props.grid} level={[...level, props.fieldGroup.id]} panelScheme={panelScheme} />
      </Collapse.Panel>
    </Collapse>
  );
}

function FieldTr(props: { field: Field; form: FormInstance<any>; allowRecordWithErrors?: boolean }) {
  return (
    <FieldFormItem
      form={props.form}
      gridId={props.field.gridId}
      key={props.field.id}
      field={props.field}
      allowRecordWithErrors={props.allowRecordWithErrors}
    />
  );
}
